import React, { useEffect, useState } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { getCountryMessage } from "../../../../../../../api";
import { fetchUnifiedProcessing } from "../../../../../me/utils";
import withSource from "../../../../../.././hocs/source-scoll";

const BannerSource = withSource(props =>{
    const { innerRef, banner } = props;

    return <div className={cls.ConfirmBanner}>
        <a 
            href={banner.href} 
            ref={innerRef} 
            data-title="shoppingcart"  
            data-position={1} 
            data-type="Shopping Cart Banner" 
            data-content={banner.refId} 
        >
            <img src={banner.src} alt={banner.refId} />
        </a>
    </div>
});

const ConfirmBanner = props =>{
    useStyles(cls);
    const [banner, setBanner] = useState(null);

    useEffect(async () =>{
        let response = await getCountryMessage("M1396");
        setBanner(fetchUnifiedProcessing(response));
    }, []);

    return <React.Fragment>
        {
            !!banner && <BannerSource banner={banner} />
        }
    </React.Fragment>
}

export default ConfirmBanner;